/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import AddressFieldItemEdit from "./edit-item";

const AddressFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <AddressFieldItemEdit />
        </FieldListEditWrapper>
    );
};
AddressFieldEdit.displayName = "AddressFieldEdit";
export { AddressFieldEdit };
